import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const MoneyDollarShape = ({
  width = 800,
  height = 800,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="_x32_"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    style={style}
  >
    <g>
      <path
        className="st0"
        d="M300.054,92.714l62.162,16.497c1.614,0.33,2.938,1.655,3.312,3.285l16.386,62.158
		c0.441,1.826,2.037,3.107,3.905,3.107c1.885,0,3.481-1.282,3.906-3.107l16.403-62.158c0.356-1.63,1.681-2.955,3.294-3.285
		l62.166-16.497c1.817-0.34,3.108-1.961,3.108-3.829c0-1.885-1.29-3.472-3.108-3.838L409.422,68.56
		c-1.613-0.348-2.938-1.655-3.294-3.285L389.724,3.116C389.3,1.308,387.704,0,385.819,0c-1.868,0-3.464,1.308-3.905,3.116
		l-16.386,62.158c-0.374,1.63-1.698,2.937-3.312,3.285l-62.162,16.488c-1.834,0.365-3.107,1.953-3.107,3.838
		C296.946,90.753,298.22,92.374,300.054,92.714z"
      />
      <path
        className="st0"
        d="M81.607,175.333l11.7,44.413c0.323,1.316,1.468,2.225,2.801,2.225c1.342,0,2.48-0.908,2.794-2.225
		l11.708-44.413c0.246-1.171,1.206-2.113,2.369-2.36l44.42-11.767c1.299-0.271,2.225-1.443,2.225-2.768
		c0-1.325-0.926-2.462-2.225-2.734l-44.42-11.784c-1.164-0.255-2.123-1.172-2.369-2.344L98.902,97.138
		c-0.314-1.29-1.452-2.208-2.794-2.208c-1.333,0-2.478,0.917-2.801,2.208l-11.7,44.438c-0.281,1.172-1.206,2.089-2.378,2.344
		l-44.413,11.784c-1.324,0.272-2.233,1.409-2.233,2.734c0,1.324,0.908,2.496,2.233,2.768l44.413,11.767
		C80.402,173.22,81.326,174.162,81.607,175.333z"
      />
      <path
        className="st0"
        d="M38.111,367.563v40.006c0,6.597,1.325,13.025,3.966,19.41c2.64,6.368,6.597,12.692,11.869,18.874
		c2.225,2.589,4.721,5.153,7.395,7.675v-64.026c-1.749-1.307-3.447-2.623-5.102-3.956C49.352,379.925,43.265,373.922,38.111,367.563
		z"
      />
      <path
        className="st0"
        d="M79.917,468.122c6.198,4.067,12.991,7.964,20.368,11.614c3.167,1.58,6.469,3.073,9.824,4.534v-68.076
		c-10.842-4.381-20.946-9.245-30.192-14.552V468.122z"
      />
      <path
        className="st0"
        d="M128.702,422.979v68.22h-1.095c13.236,4.729,27.593,8.78,42.893,12.014v-69.314
		c-9.918-1.995-19.528-4.288-28.731-6.903C137.321,425.721,132.956,424.388,128.702,422.979z"
      />
      <path
        className="st0"
        d="M189.086,506.566c19.12,3.09,39.344,5.008,60.383,5.434v-69.731c-20.929-0.408-41.152-2.148-60.383-5.12
		V506.566z"
      />
      <path
        className="st0"
        d="M268.062,511.949c21.906-0.424,42.91-2.496,62.705-5.799v-69.314c-19.905,3.158-40.935,5.052-62.705,5.476
		V511.949z"
      />
      <path
        className="st0"
        d="M349.345,502.669c7.319-1.596,14.467-3.337,21.327-5.29c7.116-2.02,13.941-4.228,20.496-6.605v-68.585
		c-13.109,4.424-27.101,8.21-41.823,11.25V502.669z"
      />
      <path
        className="st0"
        d="M409.744,415.227v68.042c11.275-5.095,21.396-10.698,30.192-16.727v-66.257
		c-4.602,2.717-9.424,5.34-14.45,7.844C420.442,410.617,415.178,412.977,409.744,415.227z"
      />
      <path
        className="st0"
        d="M457.41,388.534h1.103v62.778c7.846-7.871,13.533-16.081,16.93-24.333c2.649-6.385,3.973-12.812,3.973-19.41
		v-39.989c-0.56,0.696-1.121,1.393-1.716,2.08C471.962,376.376,465.118,382.65,457.41,388.534z"
      />
      <path
        className="st0"
        d="M475.443,326.546c2.649-6.385,3.973-12.803,3.973-19.392c0-6.588-1.324-13.007-3.973-19.391
		c-2.633-6.376-6.588-12.702-11.87-18.874c-10.528-12.353-26.354-24.019-46.34-33.885c-39.939-19.799-96.225-32.398-158.468-32.364
		c-40.846,0-79.13,5.382-111.911,14.713c-32.789,9.314-60.06,22.636-78.874,37.995c-12.574,10.214-21.302,21.267-25.904,32.416
		c-2.64,6.384-3.966,12.803-3.966,19.391c0,6.589,1.325,13.007,3.966,19.392c2.64,6.368,6.597,12.693,11.869,18.865
		c10.545,12.371,26.371,24.019,46.34,33.894c39.938,19.808,96.237,32.399,158.48,32.374c40.855,0,79.134-5.391,111.906-14.73
		c32.79-9.314,60.077-22.627,78.876-37.978C462.113,348.739,470.858,337.686,475.443,326.546z M333.298,329.968
		c-2.895,5.229-7.506,9.687-13.78,13.38c-6.41,3.77-14.434,6.606-24.062,8.491c-4.241,0.832-8.715,1.392-13.262,1.851l1.851,22.525
		h-35.981l-0.247-22.083c-9.776-0.603-19.086-1.749-27.78-3.532c-13.147-2.7-29.329-13.262-29.329-13.262
		c-1.388-0.62-2.229-1.698-2.284-2.886c-0.059-1.188,0.628-2.377,1.919-3.21l17.265-11.394c1.805-1.188,4.475-1.401,6.478-0.535
		c0,0,11.704,7.31,20.887,9.093c9.254,1.766,18.504,2.666,27.695,2.666c11.616-0.016,21.112-1.477,28.392-4.364
		c7.216-2.887,10.37-7.251,9.598-13.092c-0.539-4.101-2.717-7.267-6.559-9.569c-3.774-2.284-9.87-3.684-18.263-4.296l-27.411-1.511
		c-16.132-1.036-28.384-3.965-36.687-8.678c-8.155-4.644-11.661-11.47-10.736-20.283c0.492-4.721,2.458-8.83,5.854-12.378
		c3.324-3.472,7.658-6.368,12.96-8.694c5.269-2.292,11.271-4.024,18.06-5.162c2.801-0.476,5.748-0.781,8.744-1.078l-0.114-10.596
		l25.632-0.068l0.857,10.4c6.194,0.323,12.12,0.884,17.698,1.75c9.547,1.434,20.169,5.909,20.169,5.909
		c1.316,0.39,2.3,1.078,2.665,1.894c0.365,0.84,0.068,1.655-0.819,2.249l-11.636,7.879c-1.265,0.849-3.387,1.087-5.238,0.535
		c0,0-8.138-3.303-14.888-4.322c-6.703-1.018-13.666-1.511-20.954-1.494c-9.497,0.017-16.539,1.112-21.111,3.311
		c-4.644,2.241-7.03,5.162-7.127,8.838c-0.098,3.371,1.502,5.986,4.89,7.837c3.396,1.868,9.156,3.091,17.346,3.583l22.979,1.222
		c17.129,0.935,30.505,3.821,40.214,8.746c9.968,5.035,16.064,12.608,18.255,22.991C336.813,319.1,336.099,324.89,333.298,329.968z
		 M444.996,314.932l-26.897,7.132c-0.714,0.136-1.291,0.722-1.443,1.443l-7.099,26.889c-0.186,0.789-0.866,1.349-1.68,1.349
		c-0.816,0-1.511-0.56-1.698-1.349l-7.098-26.889c-0.17-0.722-0.73-1.308-1.443-1.443l-26.898-7.132
		c-0.798-0.162-1.358-0.866-1.358-1.664c0-0.816,0.56-1.512,1.358-1.673l26.898-7.124c0.713-0.178,1.273-0.713,1.443-1.426
		l7.098-26.914c0.187-0.798,0.882-1.35,1.698-1.35c0.814,0,1.494,0.552,1.68,1.35l7.099,26.914c0.152,0.713,0.73,1.248,1.443,1.426
		l26.897,7.124c0.782,0.161,1.359,0.857,1.359,1.673C446.355,314.066,445.778,314.77,444.996,314.932z"
      />
    </g>
  </svg>
);

export default MoneyDollarShape;
